import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import { ThemeService } from '@ld.consumer-portal/utils';

@Component({
  selector: 'ld-migration-notification-card',
  imports: [MatProgressSpinnerModule, TranslocoDirective],
  templateUrl: './migration-notification-card.component.html',
  styleUrl: './migration-notification-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MigrationNotificationCardComponent {
  private readonly themeService = inject(ThemeService);

  protected readonly logoUrl = computed(() => this.themeService.getLogoUrl());
  protected readonly partnerDisplayName = computed(() => this.themeService.getPartnerDisplayName());

  isLoading = input(false);

  continueClick = output<void>();

  onContinue(): void {
    this.continueClick.emit();
  }
}
